module.exports = __webpack_public_path__ + "img/Nacken_Outline.27156c6.svg";